import { useQuery, useMutation } from "@tanstack/react-query";
import http_payroll from "AppQuries/utils/http_payroll";
import { Api_EndPoints } from "AppQuries/utils/Api_EndPoints";

const getCPFContributionList = async () => {
  const data = await http_payroll.get(
    `${Api_EndPoints.CPFContributionAPI}?isAll=true`
  );
  return data;
};

const getCPFContributionById = async ({ code }) => {
  const { data } = await http_payroll.get(
    `${Api_EndPoints.CPFContributionAPI}??isAll=false&code=${code}`
  );
  return data;
};

const insertCPFContribution = async (input) => {
  const { data } = await http_payroll.post(
    Api_EndPoints.CPFContributionAPI,
    input
  );
  return data;
};

const updateCPFContribution = async (input) => {
  const { data } = await http_payroll.put(
    Api_EndPoints.CPFContributionAPI,
    input
  );
  return data;
};

export const useCPFContributionQuery = () => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFContributionAPI],
    queryFn: () => getCPFContributionList(),
  });
};

export const useGetCPFContributionByIdQuery = (input) => {
  return useQuery({
    queryKey: [Api_EndPoints.CPFContributionAPI],
    queryFn: () => getCPFContributionById(input),
    refetchOnWindowFocus: false,
  });
};

export const useInsertCPFContributionMutation = () => {
  return useMutation({
    mutationFn: insertCPFContribution,
  });
};

export const useUpdateCPFContributionMutation = () => {
  return useMutation({
    mutationFn: updateCPFContribution,
  });
};
